import type { ReactNode } from 'react';

import styles from './website-editorial.module.css';
import { WebsiteLandscapeVideo } from './website-landscape-video';

/** Scenic environment for the same presentational software components used elsewhere. */
export function WebsiteEditorialScene({
  children,
  footer,
  ocean = false,
  video,
  studio = false,
}: {
  children: ReactNode;
  footer?: ReactNode;
  ocean?: boolean;
  video?: string;
  studio?: boolean;
}) {
  return (
    <div
      className={styles.scene}
      data-footer={footer ? true : undefined}
      data-studio={studio || undefined}
      data-editorial-scene
      data-ocean={ocean || undefined}
    >
      {video && <WebsiteLandscapeVideo src={video} className={styles.video} />}
      <div className={styles.glass}>{children}</div>
      {footer}
    </div>
  );
}
